import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useSurveyId } from './useSurveyId'

const document = graphql(`
  mutation BrandGroupListPage_CreateBrandGroup($surveyId: ID!, $name: String!) {
    createBrandGroup(surveyId: $surveyId, name: $name) {
      id
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useCreateBrandGroupMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, Variables['name'], unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const surveyId = useSurveyId()

  return useMutation({
    mutationFn: (name) =>
      graphQLRequest({ document, variables: { surveyId, name } }),
    ...options,
  })
}
